import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { ContractSearchService } from '../Services/contract-search.service';
import { PolicyManualContent } from '../Models/common.model';
import { ListViewContentPipe } from '../Models/listview-content.pipe';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'policymanual-content',
    templateUrl: './policy-manual-content.component.html',
    providers: [ListViewContentPipe]
})
export class PolicyManualContentComponent implements OnInit {
    searchContent = {} as PolicyManualContent;

    filterMetadata = { count: 0 };
    index = { count: 0 };
    initialLoad = true;

    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
        this.clearFilterCount();
    }
    @ViewChild('format') formatHtml: ElementRef;


    ngAfterContentChecked(): void {
        this.cdRef.detectChanges();
    }
    constructor(private cdRef: ChangeDetectorRef, private element: ElementRef, private highlightCount: ListViewContentPipe, public dataService: ContractSearchService, private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        this.dataService.getSearchstring$.subscribe((data) => {
            this.searchText = data;
        });

        this.dataService.getPolicyManualContent().subscribe((data: PolicyManualContent) => {
            this.searchContent = data;
            this.searchContent['ContentTextBody'] = this.sanitizer.bypassSecurityTrustHtml(this.searchContent['ContentTextBody']);
        })
        this.dataService.getPosition$.subscribe((data) => {
            data > 0 ? this.findNext(data) : this.findPrev(data);
        });
    }

    clearFilterCount() {
        this.index.count = 0;
        this.dataService.setCurrentPosition(this.index.count);
        this.filterMetadata.count = 0;
        this.dataService.setTotalSearchCount(this.filterMetadata.count);
        this.initialLoad = true;
    }
    public findNext(position: number) {
        var nextElem;

        this.find(position);
        var offset = 50;
        var current;
        var highlightedElem = this.element.nativeElement.querySelectorAll('mark');
        if (highlightedElem != null) {
            for (var elem = 0; elem < highlightedElem.length; elem++) {
                if (highlightedElem[elem].className == "swapa-contract-active") {
                    if (elem < (highlightedElem.length - 1)) {
                        nextElem = highlightedElem[elem + 1];
                    }
                    else {
                        (highlightedElem.length != 2) ? nextElem = highlightedElem[0] : nextElem = highlightedElem[elem - 1];
                    }
                    current = nextElem.offsetTop - offset;
                }
            }
        }
        this.jumpTo(current);
    }

    public findPrev(position: number) {
        var nextElem;

        this.find(position);
        var offset = 50;
        var current;
        var highlightedElem = this.element.nativeElement.querySelectorAll('mark');
        if (highlightedElem != null) {
            for (var elem = highlightedElem.length - 1; elem >= 0; elem--) {
                if (highlightedElem[elem].className == "swapa-contract-active") {
                    if (elem > 0) {
                        nextElem = highlightedElem[elem - 1];
                    }
                    else {
                        (highlightedElem.length != 2) ? nextElem = highlightedElem[highlightedElem.length - 1] : nextElem = highlightedElem[elem + 1];
                    }
                    current = nextElem.offsetTop - offset;
                }
            }
        }
        this.jumpTo(current);
    }

    public jumpTo(position): void {
        if (position != null) {
            window.scrollTo(0, position)
        }
    }

    private find(increment: number) {
        if (this.searchText) {
            //this.matchCount = this.highlight.highlight(this.searchText, this.caseSensitive);
            this.index.count += increment;

            this.index.count = this.index.count <= 0 ? this.filterMetadata.count : this.index.count;
            this.index.count = this.index.count > this.filterMetadata.count ? 1 : this.index.count;
            this.dataService.setCurrentPosition(this.index.count);

            var that = this;

            if (this.filterMetadata.count > 0) {

                //that.sectionCount.count = 0
                this.dataService.getPolicyManualContent().subscribe((data: PolicyManualContent) => {
                    this.searchContent = data;
                    this.searchContent['ContentTextBody'] = this.sanitizer.bypassSecurityTrustHtml(this.searchContent['ContentTextBody']);
                    var text = that.highlightCount.transform(this.searchContent.ContentTextBody, that.searchText, that.filterMetadata.count, that.index.count - 1, that.initialLoad = false);
                    if (text.changingThisBreaksApplicationSecurity != undefined) {
                        that.formatHtml.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                    }
                    else
                        that.formatHtml.nativeElement.innerHTML = text;
                }
                );
            }
        }
    }

}